module.exports = __webpack_public_path__ + "img/loja.994f702c.jpg";